import useModal from "@/@core/components/base-modal/hooks/useModal";
import router from "@/router";
import store from "@/store";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
  getCurrentInstance,
} from "@vue/composition-api";
import NoImgaeIcon from "@/assets/images/icons/img.svg";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import { privilegeCodeTemplateModel } from "@/models/privilege/privilege-code-template";

import useFlatPickr from "@/utils/hooks/useFlatPickr";

import {
  pageIndex,
  templateType,
  showLayout,
  expireType,
  statusAction,
  booleanData,
} from "@/configs/privilege/code-template";

export default function useCodeTemplateModal() {
  const vm = getCurrentInstance().proxy;
  const {
    fetchDetailCodeTemplate,
    createCodeTemplate,
    editCodeTemplate,
  } = privilegeCodeTemplateModel();

  const {
    openDefaultErrorModal,
    openErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal();

  const { openModal, closeModal } = useModal();

  const { resolveDate, resolveTime } = useFlatPickr();

  const isEdit = ref(false);

  const isEditorMode = ref(false);

  const formModal = reactive({
    templateSelect: "",
    templateId: null,

    // information
    status: 1,
    tracking: false,
    title: "",
    privilegeSelect: {
      img: { file: null, url: null },
      ref: "",
      name: "",
      id: null,
    },
    privilegeImg: {
      img: { file: null, url: null },
      imgUpload: { file: null, url: null },
      id: null,
      type: null,
    },
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },

    // content
    privilegeName: "",
    privilegeNameTextEditor: {
      fontName: "DBHelvethaicaX",
      fontSize: "20",
      fontStyle: [],
      fontAlign: "left",
      fontColor: "#000000",
      lineHeight: "1.15",
      seq: 0,
    },
    privilegeDesc: "",
    privilegeDescTextEditor: {
      fontName: "DBHelvethaicaX",
      fontSize: "18",
      fontStyle: [],
      fontAlign: "left",
      fontColor: "#000000",
      lineHeight: "1.15",
      seq: 1,
    },
    isLayoutRemarkShow: true,
    privilegeRemark: "",
    remarkTextEditer: {
      fontName: "DBHelvethaicaX",
      fontSize: "18",
      fontStyle: [],
      fontAlign: "left",
      fontColor: "#304864",
      lineHeight: "1.15",
      seq: 1,
    },
    remarkBgColor: "#dddfde",
    privilegeTerm: "",
    isExpire: false,
    expireType: 1,
    expTextEditor: {
      fontName: "DBHelvethaicaX",
      fontSize: "18",
      fontStyle: [],
      fontAlign: "left",
      fontColor: "#000000",
      lineHeight: "1.15",
      seq: 2,
    },
    backgroundImg: { file: null, url: null },
    logoImg: { file: null, url: null },
    colorCode: "#000000",
    expireDate: { date: null, time: null },
    redeemDate: { date: null, time: null },

    isLayoutPrivilegeNameShow: true,
    isLayoutDescShow: true,
    isLayoutTermShow: true,
    isLayoutBgShow: true,
    isLayoutLogoShow: true,

    privilegeTermEditor: {
      fontName: "DBHelvethaicaX",
      fontSize: "16",
      fontStyle: [],
      fontAlign: null,
      fontColor: "#000000",
      lineHeight: "1.15",
      seq: 3,
    },
    reorderList: [],
    colorCodeText: "#ffffff",
  });

  const onSaveModalChoosePrivilege = (obj) => {
    formModal.privilegeSelect.img.url = obj.image_url;
    formModal.privilegeSelect.ref = obj.alt_reference;
    formModal.privilegeSelect.name = obj.name_th;
    formModal.privilegeSelect.id = obj.privilege_id;
    formModal.privilegeImg.id = null;
    formModal.privilegeImg.img.url = "";

    // set default privilege name content
    formModal.privilegeName = obj.name_th;
  };

  const onSaveModalSelectImage = (obj) => {
    formModal.privilegeImg.imgUpload.url = "";
    formModal.privilegeImg.imgUpload.file = "";
    formModal.privilegeImg.img.url = obj.image_url;
    formModal.privilegeImg.id = obj.image_id;
    formModal.privilegeImg.type = obj.image_type;
  };

  const onCropImage = (image) => {
    formModal.privilegeImg.img.url = "";
    formModal.privilegeImg.imgUpload.url = image.url;
    formModal.privilegeImg.imgUpload.file = image.file;
    formModal.privilegeImg.id = null;
    formModal.privilegeImg.type = 3;
  };

  const onUploadBgImage = (image) => {
    formModal.backgroundImg.file = image.file;
    formModal.backgroundImg.url = image.url;
  };

  const onUploadLogoImage = (image) => {
    formModal.logoImg.file = image.file;
    formModal.logoImg.url = image.url;
  };

  const { templateType } = router.currentRoute.query;
  const templateId = router.currentRoute.params.ref;

  const getTemplate = () => {
    if (templateType) formModal.templateSelect = parseInt(templateType);
    if (templateId) formModal.templateId = parseInt(templateId);
  };

  const fetchDataCodeTemplate = (templateId = 0, isReload = false) => {
    if (!templateId) return;
    window.$loading(true);
    fetchDetailCodeTemplate.payload.Template_Id = templateId;

    store
      .dispatch("api/apiRequest", fetchDetailCodeTemplate)
      .then((response) => {
        response = response.data.resp;

        // information
        formModal.templateId = response.templateid;
        formModal.templateSelect = response.template_type;
        formModal.status = response.status == statusAction.ACTIVE;
        formModal.tracking = response.tracking;
        formModal.title = response.title;
        formModal.privilegeSelect.id = response.privilegeid;
        formModal.privilegeSelect.img.url = response.privilege_image;
        formModal.privilegeSelect.name = response.privilege_name_main_th;
        formModal.privilegeSelect.ref = response.privilege_reference;
        formModal.privilegeImg.type = response.image_type;
        if (response.image_type == 3) {
          formModal.privilegeImg.imgUpload.url = response.image_url;
        } else {
          formModal.privilegeImg.img.url = response.image_url;
          formModal.privilegeImg.id = response.imageid;
        }
        formModal.validFrom.date = resolveDate(response.valid_from);
        formModal.validFrom.time = resolveTime(response.valid_from);
        formModal.validThrough.date = resolveDate(response.valid_through);
        formModal.validThrough.time = resolveTime(response.valid_through);

        // content
        formModal.privilegeName = response.privilege_name || "";
        formModal.privilegeDesc = response.description;

        formModal.privilegeRemark = response.remark_htmleditor;
        formModal.remarkBgColor = response.remark_color_bg || "#dddfdb";

        formModal.privilegeTerm = response.condition_htmleditor;
        formModal.isExpire = response.isexpire == booleanData.TRUE;
        formModal.expireType = response.exp_mode;
        formModal.backgroundImg.url = response.background_image_url;
        formModal.logoImg.url = response.logo_image_url;
        formModal.colorCode = response.color_code || "#000000";
        formModal.colorCodeText = response.color_icon || "#ffffff";
        formModal.expireDate.date = response.exp_dt
          ? resolveDate(response.exp_dt)
          : null;
        formModal.expireDate.time = response.exp_dt
          ? resolveTime(response.exp_dt)
          : null;
        formModal.redeemDate.date = response.exp_dt
          ? resolveDate(response.exp_dt)
          : null;
        formModal.redeemDate.time = response.exp_dt
          ? resolveTime(response.exp_dt)
          : null;
        formModal.isLayoutPrivilegeNameShow =
          response.privilege_name_show_layout == booleanData.TRUE;
        formModal.isLayoutDescShow =
          response.description_show_layout == booleanData.TRUE;
        formModal.isLayoutRemarkShow =
          response.remark_show_layout == booleanData.TRUE;
        formModal.isLayoutTermShow =
          response.condition_show_layout == booleanData.TRUE;
        formModal.isLayoutBgShow =
          response.background_show_layout == booleanData.TRUE;
        formModal.isLayoutLogoShow =
          response.logo_show_layout == booleanData.TRUE;

        formModal.privilegeNameTextEditor = response.privilege_name_texteditor
          ? {
              fontName: response.privilege_name_texteditor.fontname,
              fontSize: response.privilege_name_texteditor.fontsize,
              fontStyle: response.privilege_name_texteditor.fontstyle,
              fontAlign: response.privilege_name_texteditor.fontalign,
              fontColor: response.privilege_name_texteditor.fontcolor,
              lineHeight:
                response.privilege_name_texteditor.lineheight || "1.15",
              seq: response.privilege_name_texteditor.seq,
              key: "privilegeNameTextEditor",
            }
          : null;
        formModal.privilegeDescTextEditor = response.description_texteditor
          ? {
              fontName: response.description_texteditor.fontname,
              fontSize: response.description_texteditor.fontsize,
              fontStyle: response.description_texteditor.fontstyle,
              fontAlign: response.description_texteditor.fontalign,
              fontColor: response.description_texteditor.fontcolor,
              lineHeight: response.description_texteditor.lineheight || "1.15",
              seq: response.description_texteditor.seq,
              key: "privilegeDescTextEditor",
            }
          : null;
        formModal.expTextEditor = response.exp_texteditor
          ? {
              fontName: response.exp_texteditor.fontname,
              fontSize: response.exp_texteditor.fontsize,
              fontStyle: response.exp_texteditor.fontstyle,
              fontAlign: response.exp_texteditor.fontalign,
              fontColor: response.exp_texteditor.fontcolor,
              lineHeight: response.exp_texteditor.lineheight || "1.15",
              seq: response.exp_texteditor.seq,
              key: "expTextEditor",
            }
          : null;
        formModal.remarkTextEditer = response.remark_texteditor
          ? {
              fontName: response.remark_texteditor.fontname,
              fontSize: response.remark_texteditor.fontsize,
              fontStyle: response.remark_texteditor.fontstyle,
              fontAlign: response.remark_texteditor.fontalign,
              fontColor: response.remark_texteditor.fontcolor,
              lineHeight: response.remark_texteditor.lineheight || "1.15",
              seq: response.remark_texteditor.seq,
              key: "remarkTextEditer",
            }
          : null;
        formModal.privilegeTermEditor = response.condition_texteditor
          ? {
              fontName: response.condition_texteditor.fontname,
              fontSize: response.condition_texteditor.fontsize,
              fontStyle: response.condition_texteditor.fontstyle,
              fontAlign: response.condition_texteditor.fontalign,
              fontColor: response.condition_texteditor.fontcolor,
              lineHeight: response.condition_texteditor.lineheight || "1.15",
              seq: response.condition_texteditor.seq,
              key: "privilegeTermEditor",
            }
          : null;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        if (isReload) {
          openSuccessModal(
            "บันทึกสำเร็จ",
            "*กล่องข้อความนี้จะปิดอัตโนมัติ",
            null,
            null,
            null,
            "",
            false,
            false
          );

          setTimeout(() => {
            location.reload();
          }, 800);
        }
        window.$loading(false);
      });
  };

  const onEditForm = (payload) => {
    window.$loading(true);
    editCodeTemplate.payload = payload;

    store
      .dispatch("api/apiFormRequest", editCodeTemplate)
      .then((response) => {
        const templateId = response.data.resp.templateid;
        fetchDataCodeTemplate(templateId, true);
        //openSuccessModal("บันทึกสำเร็จ");
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onCreateForm = (payload) => {
    window.$loading(true);
    createCodeTemplate.payload = payload;

    store
      .dispatch("api/apiFormRequest", createCodeTemplate)
      .then((response) => {
        const templateId = response.data.resp.templateid;
        const templateType = response.data.resp.template_type;
        const privilegeRef = response.data.resp.privilege_reference;

        isEdit.value = true;

        router
          .push(
            `/privilege/code-template/info/${templateId}?templateType=${templateType}&privilegeRef=${privilegeRef}`
          )
          .catch(() => {});
        openSuccessModal("บันทึกสำเร็จ");
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const resolveDateFormat = (dateStr) => {
    if (!dateStr) return;
    const dateSplit = dateStr.split("-");
    const date = dateSplit[0];
    const month = dateSplit[1];
    const year = dateSplit[2];

    return `${year}-${month}-${date}`;
  };

  const onSubmitReorder = () => {
    if (formModal.reorderList.length > 0) {
      const templateList = [...formModal.reorderList];

      if (templateList && templateList.length > 0) {
        const privilegeNameNewIndex = templateList.findIndex(
          (name) => name === "privilegeNameTextEditor"
        );
        const privilegeDescNewIndex = templateList.findIndex(
          (name) => name === "privilegeDescTextEditor"
        );
        const expTextEditorNewIndex = templateList.findIndex(
          (name) => name === "expTextEditor"
        );
        const privilegeTermNewIndex = templateList.findIndex(
          (name) => name === "privilegeTermEditor"
        );

        if (privilegeNameNewIndex !== -1)
          formModal.privilegeNameTextEditor.seq = privilegeNameNewIndex;
        if (privilegeDescNewIndex !== -1)
          formModal.privilegeDescTextEditor.seq = privilegeDescNewIndex;
        if (expTextEditorNewIndex !== -1)
          formModal.expTextEditor.seq = expTextEditorNewIndex;
        if (privilegeTermNewIndex !== -1)
          formModal.privilegeTermEditor.seq = privilegeTermNewIndex;
      }
    }

    onSubmitPayload();
  };

  const onSubmitPayload = () => {
    const payload = {
      Template_Id: formModal.templateId,
      Template_Type: formModal.templateSelect,
      Template_Type_Desc: formModal.templateSelect
        ? `Template${formModal.templateSelect}`
        : null,
      Status: formModal.status == true ? 1 : 2,
      Tracking: formModal.tracking,
      Title: formModal.title,
      Privilege_Id: formModal.privilegeSelect.id,
      Image_Type: formModal.privilegeImg.type,
      ImageId: formModal.privilegeImg.id,
      Image_url: formModal.privilegeImg.imgUpload.file,
      Valid_From:
        formModal.validFrom.date && formModal.validFrom.time
          ? `${resolveDateFormat(formModal.validFrom.date)} ${
              formModal.validFrom.time
            }`
          : null,
      Valid_Through:
        formModal.validThrough.date && formModal.validThrough.time
          ? `${resolveDateFormat(formModal.validThrough.date)} ${
              formModal.validThrough.time
            }`
          : null,
      Privilege_Name_Show_Layout: formModal.privilegeName ? 1 : 0,
      Privilege_Name: formModal.privilegeName,
      Privilege_Name_TextEditor: JSON.stringify(
        formModal.privilegeNameTextEditor
      ),
      Description_Show_Layout: formModal.privilegeDesc ? 1 : 0,
      Description: formModal.privilegeDesc,
      Description_TextEditor: JSON.stringify(formModal.privilegeDescTextEditor),
      Condition_Show_Layout: formModal.privilegeTerm ? 1 : 0,
      Condition_HtmlEditor: formModal.privilegeTerm,
      Remark_Show_Layout: formModal.privilegeRemark ? 1 : 0,
      Remark_HtmlEditor: formModal.privilegeRemark,
      Remark_TextEditor: JSON.stringify(formModal.remarkTextEditer),
      Remark_Color_bg: formModal.remarkBgColor,
      isExpire: formModal.expireDate.date && formModal.expireDate.time ? 1 : 0,
      Exp_Mode: formModal.expireType,
      Exp_DT: formModal.isExpire
        ? formModal.expireType == 1
          ? formModal.expireDate.date && formModal.expireDate.time
            ? `${resolveDateFormat(formModal.expireDate.date)} ${
                formModal.expireDate.time
              }`
            : null
          : formModal.redeemDate.date && formModal.redeemDate.time
          ? `${resolveDateFormat(formModal.redeemDate.date)} ${
              formModal.redeemDate.time
            }`
          : null
        : null,
      Exp_TextEditor: JSON.stringify(formModal.expTextEditor),
      Background_Show_Layout: formModal.backgroundImg.url ? 1 : 0,
      Background_Image_Url: formModal.backgroundImg.file,
      Logo_Show_Layout: formModal.logoImg.url ? 1 : 0,
      Logo_Image_Url: formModal.logoImg.file,
      Color_Code: formModal.colorCode,
      Color_Icon: formModal.colorCodeText,
      Condition_TextEditor: JSON.stringify(formModal.privilegeTermEditor),
      IsDelete_Background_Image_Url: formModal.backgroundImg.url ? false : true,
      IsDelete_Logo_Image_Url: formModal.logoImg.url ? false : true,
    };
    if (isEdit.value == true) {
      // Edit
      // remove payload obj not use for api edit
      delete payload.Template_Type;
      delete payload.Template_Type_Desc;
      return onEditForm(payload);
    }

    // Create
    // remove payload obj not use for api create
    delete payload.Template_Id;
    delete payload.IsDelete_Background_Image_Url;
    delete payload.IsDelete_Logo_Image_Url;
    return onCreateForm(payload);
  };

  const onSubmitForm = () => {
    onSubmitReorder();
  };

  // Manage Editor Data Function Zone

  const tabIndex = ref(0);

  const onChangeFormData = (updateData) => {
    vm.$nextTick(() => {
      // information
      formModal.status = updateData.status == statusAction.ACTIVE;
      formModal.tracking = updateData.tracking;
      formModal.title = updateData.title;
      formModal.privilegeSelect.id = updateData.privilegeSelect.id;
      formModal.privilegeSelect.img.url = updateData.privilegeSelect.img.url;
      formModal.privilegeSelect.name = updateData.privilegeSelect.name;
      formModal.privilegeSelect.ref = updateData.privilegeSelect.ref;
      formModal.privilegeImg.img.url = updateData.privilegeImg.img.url;
      formModal.privilegeImg.imgUpload.url =
        updateData.privilegeImg.imgUpload.url;
      formModal.privilegeImg.id = updateData.privilegeImg.id;

      formModal.validFrom.date = updateData.validFrom.date;
      formModal.validFrom.time = updateData.validFrom.time;
      formModal.validThrough.date = updateData.validThrough.date;
      formModal.validThrough.time = updateData.validThrough.time;

      // content
      formModal.privilegeName = updateData.privilegeName;
      formModal.privilegeDesc = updateData.privilegeDesc;
      formModal.privilegeRemark = updateData.privilegeRemark;
      formModal.remarkBgColor = updateData.remarkBgColor;
      formModal.privilegeTerm = updateData.privilegeTerm;
      formModal.isExpire = updateData.isExpire;
      formModal.expireType = parseInt(updateData.expireType);
      formModal.backgroundImg.url = updateData.backgroundImg.url;
      formModal.logoImg.url = updateData.logoImg.url;
      formModal.colorCode = updateData.colorCode;
      formModal.colorCodeText = updateData.colorCodeText;
      formModal.expireDate.date =
        parseInt(updateData.expireType) == expireType.EXPIRE_DATE
          ? updateData.expireDate.date
          : null;
      formModal.expireDate.time =
        parseInt(updateData.expireType) == expireType.EXPIRE_DATE
          ? updateData.expireDate.time
          : null;
      formModal.redeemDate.date =
        parseInt(updateData.expireType) == expireType.REDEEM_DATE
          ? updateData.redeemDate.date
          : null;
      formModal.redeemDate.time =
        parseInt(updateData.expireType) == expireType.REDEEM_DATE
          ? updateData.redeemDate.time
          : null;

      formModal.isLayoutPrivilegeNameShow =
        updateData.isLayoutPrivilegeNameShow;
      formModal.isLayoutDescShow = updateData.isLayoutDescShow;
      formModal.isLayoutRemarkShow = updateData.isLayoutRemarkShow;
      formModal.isLayoutTermShow = updateData.isLayoutTermShow;
      formModal.isLayoutBgShow = updateData.isLayoutBgShow;
      formModal.isLayoutLogoShow = updateData.isLayoutLogoShow;
    });
  };

  const onUpdateEditor = (editorId, editorData) => {
    const editorChange = formModal[editorId];

    if (editorChange) {
      vm.$nextTick(() => {
        editorChange.fontName =
          editorData.fontName?.value || editorData.fontName;
        editorChange.fontSize = editorData.fontSize;
        editorChange.fontStyle = editorData.fontStyle;
        editorChange.fontAlign = editorData.fontAlign;
        editorChange.fontColor = editorData.fontColor;
        editorChange.lineHeight = editorData.lineHeight;
      });
    }
  };

  /// ////

  const editorHistoryData = reactive({
    payload: [],
    store: [],
  });

  const editorData = reactive({
    fontName: null,
    fontSize: null,
    fontStyle: [],
    fontAlign: null,
    fontColor: "#000000",
    lineHeight: "1.15",
  });

  const editorSelectId = ref(null);

  const onUndoEditorData = () => {
    const selectId = editorSelectId.value;
    var selectList = [...editorHistoryData.payload[selectId]];

    if (!selectId && !selectList) return;
    if (selectList.length < 2) return;

    // mange history store data
    var storeSelectList = editorHistoryData.store.filter(
      (o) => o.historyName === selectId
    );
    if (storeSelectList.length > 0) {
      //storeSelectList.pop(); //undo logic
      storeSelectList = storeSelectList.slice(0, 1);
      editorHistoryData.store = [...storeSelectList]; // reset logic
    }

    // mange history list data
    if (selectList.length > 0) {
      //selectList.pop(); //undo logic
      selectList = selectList.slice(0, 1);
      editorHistoryData.payload[selectId] = [...selectList]; // reset logic
    }

    // change editor data
    //onChangeEditorData(selectList[selectList.length - 1], true); //undo logic
    onChangeEditorData(selectList[0], true); // reset logic
  };

  const onChangeEditorData = (event, isUndo = false) => {
    const selectId = editorSelectId.value;

    if (selectId && isUndo == false) {
      event.historyName = selectId;

      // check duplicate editorHistoryData array of object
      if (editorHistoryData.store.length > 0) {
        const filterObj = editorHistoryData.store.filter(
          (o) => o.historyName === selectId
        );

        if (
          filterObj.length > 0 &&
          JSON.stringify(filterObj[filterObj.length - 1]) ===
            JSON.stringify(event)
        )
          return;
      }

      //  history store data
      editorHistoryData.store.push({ ...event });

      // group history list data from history store
      editorHistoryData.payload = editorHistoryData.store.reduce(
        (group, module) => {
          const { historyName } = module;
          group[historyName] = group[historyName] ?? [];
          group[historyName].push(module);
          return group;
        },
        {}
      );
    }

    vm.$nextTick(() => {
      editorData.fontName = event.fontName?.value || event.fontName;
      editorData.fontSize = event.fontSize;
      editorData.fontStyle = event.fontStyle;
      editorData.fontAlign = event.fontAlign;
      editorData.fontColor = event.fontColor;
      editorData.lineHeight = event.lineHeight;
      onUpdateEditor(editorSelectId.value, editorData);
    });
  };

  const onSelectEditor = (event, isRemove = false) => {
    editorSelectId.value = event;
    if (isRemove) return onRemoveTemplateContent(isRemove);

    const selectData = formModal[event];

    vm.$nextTick(() => {
      if (event) {
        if (selectData !== undefined) {
          editorData.fontName =
            selectData.fontName?.value || selectData.fontName;
          editorData.fontSize = selectData.fontSize;
          editorData.fontStyle = selectData.fontStyle;
          editorData.fontAlign = selectData.fontAlign;
          editorData.fontColor = selectData.fontColor;
          editorData.lineHeight = selectData.lineHeight;
        }
      }
    });
  };

  const onRemoveTemplateContent = (isShowTempContent) => {
    if (editorSelectId.value && isShowTempContent) {
      switch (editorSelectId.value) {
        case "templateBgEditor":
          formModal.backgroundImg.url = null;
          formModal.backgroundImg.file = null;
          return (formModal.isLayoutBgShow = !formModal.isLayoutBgShow);
        case "templateLogoEditor":
          formModal.logoImg.url = null;
          formModal.logoImg.file = null;
          return (formModal.isLayoutLogoShow = !formModal.isLayoutLogoShow);
        case "privilegeNameTextEditor":
          formModal.privilegeName = "";
          return (formModal.isLayoutPrivilegeNameShow = !formModal.isLayoutPrivilegeNameShow);
        case "privilegeDescTextEditor":
          formModal.privilegeDesc = "";
          return (formModal.isLayoutDescShow = !formModal.isLayoutDescShow);
        case "expTextEditor":
          formModal.expireDate.date = null;
          formModal.expireDate.time = null;
          return (formModal.isExpire = !formModal.isExpire);
        case "remarkTextEditer":
          formModal.privilegeRemark = "";
          formModal.remarkBgColor = "#dddfdb";
          formModal.remarkTextEditer = {
            fontName: "DBHelvethaicaX",
            fontSize: "18",
            fontStyle: [],
            fontAlign: "left",
            fontColor: "#304864",
            lineHeight: "1.15",
            seq: 1,
          };
          return (formModal.isLayoutRemarkShow = !formModal.isLayoutRemarkShow);
        case "privilegeTermEditor":
          formModal.privilegeTerm = "";
          formModal.privilegeTermEditor = {
            fontName: "DBHelvethaicaX",
            fontSize: "16",
            fontStyle: [],
            fontAlign: null,
            fontColor: "#000000",
            lineHeight: "1.15",
            seq: 3,
          };
          return (formModal.isLayoutTermShow = !formModal.isLayoutTermShow);
        default:
          return;
      }
    }
  };

  const onReorderTemplate = (templateListSeq = []) => {
    if (templateListSeq.length <= 0) return;
    formModal.reorderList = [...templateListSeq];
  };

  const onToggleMode = () => {
    isEditorMode.value = !isEditorMode.value;

    if (isEditorMode.value == true) {
      tabIndex.value = pageIndex.CONTENT_PAGE;
    } else {
      tabIndex.value = pageIndex.INFO_PAGE;
    }
  };

  const onChangeTab = (tabIndex) => {
    if (tabIndex == pageIndex.CONTENT_PAGE) isEditorMode.value = true;
    else isEditorMode.value = false;
  };

  onBeforeMount(() => {
    isEdit.value = false;
    getTemplate();
    if (router.currentRoute.query.privilegeRef) {
      isEdit.value = true;
      fetchDataCodeTemplate(formModal.templateId);
    }
  });

  return {
    formModal,
    isEdit,
    getTemplate,
    onSaveModalChoosePrivilege,
    onSaveModalSelectImage,

    onUploadBgImage,
    onUploadLogoImage,
    fetchDataCodeTemplate,
    onSubmitForm,
    onChangeFormData,
    onUpdateEditor,
    tabIndex,
    editorSelectId,
    editorHistoryData,
    editorData,
    onChangeEditorData,
    onSelectEditor,
    onUndoEditorData,
    onReorderTemplate,
    isEditorMode,
    onToggleMode,
    onChangeTab,
    pageIndex,

    onCropImage,
  };
}
